function formatAmount(amount) {
  // Convert to a number
  const number = parseFloat(amount);

  // Check if it's a valid number
  if (isNaN(number)) {
    return "Invalid amount";
  }

  // Format with commas and 2 decimal places
  return number.toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}
export default formatAmount;

export const formatCurrencyAmount = (value) => {
  if (value === "" || value === null || value === undefined) return "-";

  // Convert everything to string first, then remove commas
  const cleaned = value.toString().replace(/,/g, "");

  // If still not a number, return as-is
  if (isNaN(cleaned)) return value;

  const num = parseFloat(cleaned);
  return `$${num.toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
};
